import { html } from "common-tags"

export function parseZed(
  description: string,
  tabTrigger: string,
  snippet: string
) {
  const separatedSnippet = snippet
    .replace(/\\/g, "\\\\")
    .replace(/"/g, '\\"')
    .split("\n")
  const separatedSnippetLength = separatedSnippet.length

  const newSnippet = separatedSnippet.map((line, index) => {
    return index === separatedSnippetLength - 1 ? `"${line}"` : `"${line}",`
  })
  return html`
    "${description}": { "prefix": "${tabTrigger}", "body": [
    ${newSnippet.join("\n")} ], "description": "${description}" }
  `
}
